import React from 'react'

const DashBoardMainWrapper = ({ children }) => {
  return (
    <div className='w-full p-2 py-20 lg:p-20 lg:pt-40'>{children}</div>
  )
}

export default DashBoardMainWrapper